export default __webpack_public_path__ + "static/media/AddReferencesBanner.bc56b09f.svg";